import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function ReturnOnEquity() {
    const [netWorth, setNetWorth] = useState(0);
    const [netProfit, setNetProfit] = useState(0);
    const [months, setMonths] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {

        if (parseInt(months) == ' ') {
            setTotal(
                (parseInt(netWorth) * 12 / parseInt(netProfit)) * 100
            );
        }
        else {
            setTotal(
                (((parseInt(netWorth) / parseInt(months)) * 12) / parseInt(netProfit)) *100
            );
        }
    }, [netWorth, months, netProfit])

    function clickResult() {
        history.push(
            {
                pathname: `/returnonequityresult?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        netWorth: numberValidation,
        netProfit: numberValidation,
        months: monthValidation
    });

    const def = <span>Measures how effectively a dealership uses its capital to generate profits.
                                    Annualized total dealership net profit ÷ net worth/owner equity + 60% LIFO reserve.</span>;

    return (
        <Formik
            initialValues={{ netWorth: "", netProfit: "", months: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Return On Equity</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="netWorth">
                                            <Form.Label>Net Worth</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="netWorth" isInvalid={!!errors.netWorth}
                                                    value={values.netWorth} onChange={e => { handleChange(e); setNetWorth(e.target.value) }}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.netWorth}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="netProfit">
                                            <Form.Label>Net Profit before Tax</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="netProfit" isInvalid={!!errors.netProfit}
                                                    value={values.netProfit} onChange={e => { handleChange(e); setNetProfit(e.target.value) }}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.netProfit}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="months">
                                            <Form.Label># of Months of Profit $ Above</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>#</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="months" isInvalid={!!errors.months}
                                                    value={values.months} onChange={e => { handleChange(e); setMonths(e.target.value) }}
                                                />
                                                <Form.Control.Feedback type="invalid">{errors.months}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function ReturnOnEquityResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Return On Equity";
    const total = urlParams.get('total') + "%";
    const ratio = "25 - 30%";

    const cond = parseFloat(total) >= 25;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}


export {
    ReturnOnEquity,
    ReturnOnEquityResult
}